<template>
  <div class="quiz-option-title d-flex align-items-center">
    <eg-b-button
      variant="outline-secondary"
      class="option-button custom-outline"
      :class="{ selected }"
      @click="$emit('click')"
    >
      <img
        v-if="getIconPath(icon)"
        :src="getIconPath(icon)"
        alt="icon"
        class="text-info"
      />

      {{ label }}
    </eg-b-button>
  </div>
</template>

<script>
export default {
  name: "QuizOption",

  props: {
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },

    selected: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    getIconPath(icon) {
      if (!icon) {
        return null;
      }

      try {
        return require(`@/assets/icons/${icon}.svg`);
      } catch (error) {
        console.warn(`Icon not found: ${icon}.svg`, error);
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.quiz-option-title {
  cursor: pointer;

  .option-button {
    min-height: 48px;
    width: 340px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #000;
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;

    .text-info {
      margin-right: 10px;
    }

    &.selected {
      color: #532cb5;
      background-color: #f3e8fc;
    }
  }
}

.custom-outline {
  border-color: #dfdfdf !important;
}
</style>
